import { TComplimentaryProductInfo, TState } from 'pages/dimensions/store/dimensions';
import { TComplimentaryProductsState } from 'pages/calculation/types/complimentary-products-state.type';

type TUpdateCheckedProductsParams = {
  prevState: TState;
  variantProductId: string;
  productId: string;
  isProductChecked: boolean | undefined;
};

type TBuildComplimentaryStateParams = {
  prevState: TComplimentaryProductsState;
  productId: string;
  variant: TComplimentaryProductInfo;
};

export const updateCheckedProducts = ({
  prevState,
  variantProductId,
  productId,
  isProductChecked,
}: TUpdateCheckedProductsParams): TState => {
  const productIndex = prevState.checkedProducts.findIndex(product => product.id === productId);

  // Если товар не найден, просто добавляем новый
  if (productIndex === -1) {
    return {
      ...prevState,
      checkedProducts: [
        ...prevState.checkedProducts,
        { id: variantProductId, isChecked: isProductChecked ?? false },
      ],
    };
  }

  // Заменяем товар на вариант
  return {
    ...prevState,
    checkedProducts: prevState.checkedProducts.map((product, index) =>
      index === productIndex ? { id: variantProductId, isChecked: isProductChecked ?? false } : product
    ),
  };
};

export const buildComplimentaryState = ({
  prevState,
  productId,
  variant,
}: TBuildComplimentaryStateParams): TComplimentaryProductsState => {
  const { [productId]: removed, ...rest } = prevState;

  return {
    ...rest,
    [variant.productId]: {
      ...variant,
      isSelectedAsVariant: true,
    },
  };
};
